<template>
    <div v-if="warningZone">
        <!-- <h1>Estas con Nosotros?</h1> -->
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            events: [
                "click",
                "mousemove",
                "mousedown",
                "scroll",
                "keypress",
                "load",
            ],
            warningTimer: null,
            logoutTimer: null,
            reloadPageTimer: null,
            warningZone: false,
            inactivityTime: 10 * 60 * 1000,
            routeCurrent: this.$router.currentRoute.name,
        };
    },
    created() {},
    mounted() {
        this.events.forEach(function (event) {
            window.addEventListener(event, this.resetTimer);
        }, this);

        this.setTimers();
    },
    destroyed() {
        this.events.forEach(function (event) {
            window.removeEventListener(event, this.resetTimer);
        }, this);

        this.setTimers();
    },
    methods: {
        setTimers: function () {
            this.reloadPageTimer = setTimeout(this.destroySession, this.inactivityTime);
        },
        warningMessage: function () {
            this.warningZone = true;
        },
        destroySession: function () {
            if (this.$router.currentRoute.name === "home" && !this.$store.getters.authStateGuest) {
                this.$store.dispatch("setLogout");
                return;
            } else if (this.$router.currentRoute.name != "home" && this.$router.currentRoute.matched.some((record) => record.meta.requiresAuth)) {
                this.$store.dispatch("setLogout");
                this.$router.push({ name: "home" });
                return;
            } else {} 
        },
        resetTimer: function () {
            clearTimeout(this.warningTimer);
            clearTimeout(this.logoutTimer);
            clearTimeout(this.reloadPageTimer);

            this.setTimers();
        },
    },
};
</script>

<style></style>
